module.exports = __webpack_public_path__ + "static/media/HandDigtalBackgrond-3-BG-01.8125b765.png";